// extracted by mini-css-extract-plugin
export default {"FlightListStatus":"FlightListStatus_FlightListStatus__NjA5N"};